import { createApp } from 'vue';
import App from './App.vue';
import store from "./store/index.js";
import router from "./router";
import "./assets/css/nucleo-icons.css";
import "./assets/css/nucleo-svg.css";
import "qalendar/dist/style.css";
import ArgonDashboard from "./argon-dashboard";
import VueDatePicker from '@vuepic/vue-datepicker';
import VueCookies from 'vue-cookies';
import 'swiper/css/bundle';

if ('serviceWorker' in navigator) {
    navigator.serviceWorker.getRegistrations().then(function(registrations) {
        for(let registration of registrations) {
            registration.unregister();
        }
    }).catch(function(err) {
        console.log('Service Worker registration failed: ', err);
    });
}

caches.keys().then(function(names) {
    for (let name of names)
        caches.delete(name);
});

// import './registerServiceWorker';
// import { initializeApp } from 'firebase/app';
// import { getMessaging, getToken, onMessage } from 'firebase/messaging';

// const firebaseConfig = {
//     apiKey: "AIzaSyArUlFeRuRafGD9iWjBJain4DUwwz40uKw",
//     authDomain: "pwa-camera-18de5.firebaseapp.com",
//     databaseURL: "https://pwa-camera-18de5-default-rtdb.firebaseio.com",
//     projectId: "pwa-camera-18de5",
//     storageBucket: "pwa-camera-18de5.appspot.com",
//     messagingSenderId: "856555749414",
//     appId: "1:856555749414:web:5068a3ff9ace116d52a6e7"
// };

// initializeApp(firebaseConfig);

// const messaging = getMessaging();
// getToken(messaging, { vapidKey: 'YOUR_VAPID_KEY' }).then((currentToken) => {
//     if (currentToken) {
//         console.log('Token:', currentToken);
//     } else {
//         console.log('No registration token available. Request permission to generate one.');
//     }
// }).catch((err) => {
//     console.log('An error occurred while retrieving token. ', err);
// });

// messaging
//   .requestPermission()
//   .then(() => {
//     document.getElementById('message').innerHTML = "Notifications allowed";
//     return messaging.getToken();
//   })
//   .then(token => {
//     document.getElementById('tokenString').innerHTML = "Token Is : " + token;
//   })
//   .catch(err => {
//     document.getElementById('errorMessage').innerHTML = document.getElementById('errorMessage').innerHTML + "; " + err;
//     console.log("No permission to send push", err);
//   });

// onMessage(messaging, payload => {
//   console.log("Message received. ", payload);
//   const { title, ...options } = payload.notification;
//   console.log(`title:${title}, options: ${options}`);
// });





// let appServerPublicKey = 'BCL7xmddFH8hmVUQcUaUjdpqcQ7VrLEKp5mvkZ_bDKY_FojxXPeDOtFC0VuBETSB0UKw2mvIDg6f6qILEx_KMOs';
// let isSubscribed = false; 
// let swRegist = null;

// function urlB64ToUint8Array(base64String) {
//     const padding = '='.repeat((4 - base64String.length % 4) % 4);
//     const base64 = (base64String + padding)
//       .replace(/-/g, '+')
//       .replace(/_/g, '/');

//     console.log(base64);

//     const rawData = window.atob(base64);
//     const outputArray = new Uint8Array(rawData.length);
  
//     for (let i = 0; i < rawData.length; ++i) {
//       outputArray[i] = rawData.charCodeAt(i);
//     }
//     return outputArray;
// }


// // 구독 버튼 상태 갱신
// function updateButton () {
//     const pushButton = document.getElementById('subscribe');
    
//     // 알림 권한 거부 처리
//     if (Notification.permission === 'denied') {
//         pushButton.textContent = 'Push Messaging Blocked';
//         pushButton.disabled = true;
//         updateSubscription(null);
//         return;
//     }

//     if (isSubscribed) {
//         pushButton.textContent = 'Disable Push Messaging';
//     } else {
//         pushButton.textContent = 'Enable Push Messaging';
//     }
    
//     pushButton.disabled = false;
// }

// // 구독 정보 갱신
// function updateSubscription (subscription) {
//     // TODO: 구독 정보 서버로 전송
//     let detailArea = document.getElementById('subscription_detail')

//     if (subscription) {
//         detailArea.innerText = JSON.stringify(subscription)
//         detailArea.parentElement.classList.remove('hide')
//     } else {
//         detailArea.parentElement.classList.add('hide')
//     }
// }

// // 알림 구독
// function subscribe () {
//     const applicationServerKey = urlB64ToUint8Array(appServerPublicKey);
//     swRegist.pushManager.subscribe({
//         userVisibleOnly: true,
//         applicationServerKey: applicationServerKey
//     })
//     .then(subscription => {
//         console.log('User is subscribed.');
//         updateSubscription(subscription);
//         isSubscribed = true;
//         updateButton();
//     })
//     .catch(err => {
//         console.log('Failed to subscribe the user: ', err);
//         updateButton();
//     });
// }

// // 알림 구독 취소
// function unsubscribe () {
//     swRegist.pushManager.getSubscription()
//     .then(subscription => {
//         if (subscription) {
//         return subscription.unsubscribe();
//         }
//     })
//     .catch(error => {
//         console.log('Error unsubscribing', error);
//     })
//     .then(() => {
//         updateSubscription(null);
//         console.log('User is unsubscribed.');
//         isSubscribed = false;
//         updateButton();
//     });
// }

// // Push 초기화
// function initPush () {
//     const pushButton = document.getElementById('subscribe')
//     pushButton.addEventListener('click', () => {
//         if (isSubscribed) {
//             unsubscribe ();
//         } else {
//             subscribe();
//         }
//     });

//     swRegist.pushManager.getSubscription()
//     .then(function(subscription) {
//         isSubscribed = !(subscription === null);
//         updateSubscription(subscription);

//         if (isSubscribed) {
//             console.log('User IS subscribed.');
//         } else {
//             console.log('User is NOT subscribed.');
//         }

//         updateButton();
//     });
// }


// if ('serviceWorker' in navigator) {
//     navigator.serviceWorker.register('/service-worker.js')
//     .then(function(registration) {
//         console.log('서비스 워커 등록 성공:', registration);
//         //swRegist = registration;


//         // var title = 'Simple Title';
//         // var options = {
//         // body: 'Simple piece of body text.\nSecond line of body text :)'
//         // };
//         //registration.showNotification(title, options);

//         //initPush();

//         registration.addEventListener('updatefound', () => {
//             const newWorker = registration.installing;
//             console.log('Service Worker update found!');
    
//             newWorker.addEventListener('statechange', function () {
//               console.log('Service Worker state changed:', this.state);
//             });
//         });
//     })
//     .catch(function(error) {
//         console.log('서비스 워커 등록 실패:', error);
//     });

//     navigator.serviceWorker.addEventListener('controllerchange', () => {
//         console.log('Controller changed');
//     });

// }
  

const appInstance = createApp(App);
appInstance.use(store);
appInstance.use(router);
appInstance.use(ArgonDashboard);
appInstance.use(VueCookies);

appInstance.component('VueDatePicker', VueDatePicker);

appInstance.mount("#app");
